import { connect } from 'react-redux';

import { shouldShowDetails } from 'redux/modules/huggg';
import Unstashed from './Unstashed';

const mapStateToProps = (state) => ({
  showDetails: shouldShowDetails(state),
});

export default connect(mapStateToProps)(Unstashed);
